import React, { useRef } from "react";

interface ImageLoaderProps {
    onImageSelected: (base64: string) => void;
    refProp?: React.RefObject<{ triggerClick: () => void } | null>;
}

const ImageLoader: React.FC<ImageLoaderProps> = ({ onImageSelected, refProp }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const buffer = await file.arrayBuffer();
        const base64 = btoa(
            new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), "")
        );

        onImageSelected(base64);
    };

    // Expose triggerClick via the passed ref
    if (refProp) {
        refProp.current = {
            triggerClick: () => fileInputRef.current?.click(),
        };
    }

    return (
        <input
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            ref={fileInputRef}
            onChange={handleFileChange}
        />
    );
};

export default ImageLoader;
